module.exports = __webpack_public_path__ + "img/matt-480-60.9a18c0b6.jpg";